export default __webpack_public_path__ + "static/media/tile_reports.ca630f92.jpg";